import gql from 'graphql-tag'

export const CREATE_MESSAGE = gql`
    mutation ($input: CreateMessageInput!) {
        message(input: $input) {
            id
            title
            description
            typeOfMessage
            ip
            node
            joinMessage
            platform
            isWhatsapp
            createdAt
            systemUser {
                id
                name
                lastName
                motherLastName
                email
                profile
                status
            }
        }
    }
`
